import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { initializeFeatureBoard } from './featureBoard';
import './featureBoard.css';
import './index.css'

initializeFeatureBoard();

const container = document.getElementById('root');
const root = createRoot(container);

root.render(<App />);
